import { render, staticRenderFns } from "./delegationManage.vue?vue&type=template&id=b8619a56&scoped=true"
import script from "./delegationManage.vue?vue&type=script&lang=js"
export * from "./delegationManage.vue?vue&type=script&lang=js"
import style0 from "./delegationManage.vue?vue&type=style&index=0&id=b8619a56&prod&lang=css"
import style1 from "./delegationManage.vue?vue&type=style&index=1&id=b8619a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8619a56",
  null
  
)

export default component.exports